angular
  .module('surfsightApp.controllers')
  .controller('surfSnapshotController', [
    '$scope',
    '$timeout',
    '$interval',
    '$http',
    '$mdToast',
    function ($scope) {
      const imageData = $scope.imageData
      const imageElementId = `event-snapshot-${imageData.id}`
      $scope.imageElementId = imageElementId
      $scope.displayOptions = {
        close: true,
        ...($scope.imageData.displayOptions || {})
      }
      $scope.close = () => {
        $scope.closeImage()
      }
    }
  ])
